import moment from 'moment'
import UserAvatar from '../../User/UserAvatar'

const LastEditedCell = () => {
  return ({ last_edited_timestamp, last_edited_by }) => {
    const { name, profile_url } = last_edited_by
    const user = { ...last_edited_by, url: profile_url }

    return (
      last_edited_timestamp
        ? <div className='articles-overview__table-last-edited'>
          <div className='articles-overview__table-last-edited-date'>{moment(last_edited_timestamp * 1000).format('DD-MMM-YY HH:mm') + ' by '}</div>
          <UserAvatar user={user} openInNewTab style={{ width: '16px', height: '16px' }} />
          <a href={user.url} target='_blank'>{name}</a>
        </div>
        : null
    )
  }
}

export default LastEditedCell
